import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableParadan from "./ScroollTableParadan";
import FooterOfParadan from "./FooterOfParadan";
import FillDetailParadan from "./FillDetailParadan";
const AllParadan = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailParadan />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableParadan />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 col-12">
            <FooterOfParadan />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllParadan;
